import { render, staticRenderFns } from "./CentroHemodialiseComponente.vue?vue&type=template&id=6549d8fb&scoped=true"
import script from "./CentroHemodialiseComponente.vue?vue&type=script&lang=js"
export * from "./CentroHemodialiseComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroHemodialiseComponente.vue?vue&type=style&index=0&id=6549d8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6549d8fb",
  null
  
)

export default component.exports